import { Linkedin, Twitter, Github, Download, FileText } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950">
      {/* Media kit banner */}
      <div className="border-b border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="w-11 h-11 border border-[#0891B2]/40 bg-[#0891B2]/10 flex items-center justify-center flex-shrink-0">
              <FileText size={18} className="text-[#0891B2]" aria-hidden="true" />
            </div>
            <div>
              <div className="font-heading font-bold text-slate-900 dark:text-white text-base">Get our Media Kit</div>
              <div className="text-slate-600 dark:text-slate-400 text-sm">Full company brief, service overview & case studies · PDF</div>
            </div>
          </div>
          <a
            href="https://customer-assets.emergentagent.com/job_growth-engine-lab-5/artifacts/1knboaka_LeadTech%20Connect_Media%20Kit%20%281%29.pdf"
            download="LeadTech-Connect-Media-Kit.pdf"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent("media_kit_download", { placement: "footer" })}
            data-testid="footer-media-kit-download"
            className="inline-flex items-center gap-2 bg-[#007AFF] hover:bg-[#0056d3] text-white text-sm font-medium px-6 py-3 shadow-[0_4px_20px_rgba(0,122,255,0.25)] hover:shadow-[0_6px_28px_rgba(0,122,255,0.4)] transition-colors flex-shrink-0"
          >
            <Download size={14} /> Download Media Kit
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2 mb-4">
            <img src="/leadtech-icon.png" alt="LeadTech Connect" className="h-8 w-auto" />
            <span className="font-heading font-bold text-slate-900 dark:text-white">LeadTech<span className="text-[#0891B2]">.</span>Connect</span>
          </div>
          <p className="text-slate-600 dark:text-slate-400 text-sm max-w-sm leading-relaxed">
            B2B lead generation engineered for revenue teams. We build predictable pipeline, not vanity metrics.
          </p>
          <div className="flex gap-3 mt-6">
            <a
              href="https://in.linkedin.com/company/leadtech-connect"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="social-linkedin"
              aria-label="LinkedIn"
              className="w-9 h-9 border border-slate-300 dark:border-slate-700 hover:border-[#0891B2] hover:bg-slate-50 flex items-center justify-center transition-colors"
            >
              <Linkedin size={14} className="text-slate-600 dark:text-slate-400" />
            </a>
            <a href="#" data-testid="social-twitter" aria-label="Twitter" className="w-9 h-9 border border-slate-300 dark:border-slate-700 hover:border-[#0891B2] hover:bg-slate-50 flex items-center justify-center transition-colors">
              <Twitter size={14} className="text-slate-600 dark:text-slate-400" />
            </a>
            <a href="#" data-testid="social-github" aria-label="GitHub" className="w-9 h-9 border border-slate-300 dark:border-slate-700 hover:border-[#0891B2] hover:bg-slate-50 flex items-center justify-center transition-colors">
              <Github size={14} className="text-slate-600 dark:text-slate-400" />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-heading font-bold text-sm text-slate-900 dark:text-white uppercase tracking-widest mb-4">Services</h4>
          <ul className="space-y-3 text-sm text-slate-600 dark:text-slate-400">
            <li><a href="#services" className="hover:text-slate-900">Content Marketing</a></li>
            <li><a href="#services" className="hover:text-slate-900">SEO Marketing</a></li>
            <li><a href="#services" className="hover:text-slate-900">Lead Enrichment</a></li>
            <li><a href="#services" className="hover:text-slate-900">ABM Marketing</a></li>
            <li><a href="#services" className="hover:text-slate-900">Market Research</a></li>
            <li><a href="#services" className="hover:text-slate-900">Sales Acceleration</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-heading font-bold text-sm text-slate-900 dark:text-white uppercase tracking-widest mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-slate-600 dark:text-slate-400">
            <li>enquiry@leadtechconnect.com</li>
            <li>+1 (737) 862-1210</li>
            <li>Roscoe Blvd, Panorama City<br />Los Angeles, CA 91402, US</li>
          </ul>
          <a href="/admin/login" data-testid="footer-admin-link" className="inline-block mt-6 text-xs text-slate-400 dark:text-slate-500 hover:text-slate-700">
            Admin Login →
          </a>
        </div>
      </div>
      <div className="border-t border-slate-200 dark:border-slate-800">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-400 dark:text-slate-500">© {new Date().getFullYear()} LeadTech Connect. All rights reserved.</p>
          <p className="text-xs text-slate-400 dark:text-slate-500">Made for revenue teams that ship.</p>
        </div>
      </div>
    </footer>
  );
}
